export default __webpack_public_path__ + "static/instagram-79ea850107caae0792571fae0edf5f3d.png";